/**
 * Уведомления ползователей в браузере
 * @type {Object}
 */
const TabNotify = {
  WINDOW_FOCUSED: true,

  titleCounter: 0,

  // Запросить права на уведомления
  requestNotifyPopup() {
    if (!('Notification' in window)) return;
    if (Notification.permission === 'granted') return;
    // Проверка разрешения на отправку уведомлений
    if (Notification.permission !== 'denied') {
      Notification.requestPermission();
    }
  },

  // Показать уведомление в браузере
  setPopup({ title, icon, body, url, callback }) {
    if (this.WINDOW_FOCUSED) return;
    // Проверка поддержки браузером уведомлений
    if (!('Notification' in window)) return;
    if (Notification.permission !== 'granted') return;
    const notification = new Notification(title, { body, icon });
    notification.onclick = () => {
      window.parent.focus();
      if (url && callback) callback(url);
    };
    setTimeout(() => {
      notification.close();
    }, 5000);
  },

  // старт прослушивания фокуса страницы
  listenTabFocus() {
    let Winhidden;
    let Winstate;
    let WinvisibilityChange;
    if (typeof document.hidden !== 'undefined') {
      Winhidden = 'hidden';
      WinvisibilityChange = 'visibilitychange';
      Winstate = 'visibilityState';
    } else if (typeof document.mozHidden !== 'undefined') {
      Winhidden = 'mozHidden';
      WinvisibilityChange = 'mozvisibilitychange';
      Winstate = 'mozVisibilityState';
    } else if (typeof document.msHidden !== 'undefined') {
      Winhidden = 'msHidden';
      WinvisibilityChange = 'msvisibilitychange';
      Winstate = 'msVisibilityState';
    } else if (typeof document.webkitHidden !== 'undefined') {
      Winhidden = 'webkitHidden';
      WinvisibilityChange = 'webkitvisibilitychange';
      Winstate = 'webkitVisibilityState';
    }

    document.addEventListener(
      WinvisibilityChange,
      () => {
        const state = document[Winstate];
        if (Winhidden === state || state === 'hidden') {
          this.WINDOW_FOCUSED = false;
        } else {
          this.WINDOW_FOCUSED = true;
        }
      },
      false
    );
  },

  // изменение тайтла при новом комменте
  // в неактивном фокусе вкладки
  updateTitle() {
    if (this.WINDOW_FOCUSED) return;
    this.titleCounter += 1;
    if (this.TITLE_INTERVAL) return;
    const fixedPageTitle = document.title;
    this.TITLE_INTERVAL = setInterval(() => {
      if (this.WINDOW_FOCUSED) {
        if (this.TITLE_INTERVAL) clearInterval(this.TITLE_INTERVAL);
        document.title = fixedPageTitle;
        this.TITLE_INTERVAL = null;
        this.titleCounter = 0;
        return;
      }
      if (document.title === fixedPageTitle) {
        document.title = `${this.titleCounter} notifications`;
      } else {
        document.title = fixedPageTitle;
      }
    }, 1000);
  },
};

export default TabNotify;
